import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const logsTarefasRepository = createRepository({
  path: 'logs-tarefas',
  restApi
})

export default logsTarefasRepository
